const styles = theme => ({
  accordionTitleHead: {
    padding: '4px 15px',
    display: 'flex',
    justifyContent: 'center',
    '& > div': {
      margin: '0 !important',
    },
    '& svg': {
      fontSize: '22px',
    },
    '& p': {
      padding: '0px !important',
      paddingTop: '10px !important',
      marginLeft: '-18px',
      fontSize: '14px',
      color: theme.palette.primary.adgmBlack,
      fontWeight: 600,
      '& span:last-child': {
        color: theme.palette.primary.adgmGreen,
        padding: '0px 2px',
      },
    },
  },
  accordianDetails: {
    padding: '0px 15px 4px 15px',
    borderBottom: '1px solid #EBEEF3',
  },
  borderBottom: {
    borderBottom: '1px solid #EBEEF3',
  },
  checkboxWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  checkboxContainer: {
    '& .MuiFormControlLabel-label': {
      fontWeight: 500,
      fontSize: '14px',
      color: theme.palette.primary.adgmBlack,
    },
  },
  checkbox: {
    color: theme.palette.primary.lightADGMGreen,
  },
  checked: {
    color: theme.palette.primary.lightADGMGreen + ' !important',
  },

  '@media (max-width: 645px)': {
    checkboxContainer: {
      '& .MuiFormControlLabel-label': {
        fontSize: '12px',
      },
    },
  },
  '@media (max-width: 767px)': {
    accordionTitleHead: {
      minHeight: '48px !important',
      '& > div': {
        padding: '0',
      },
    },
  },
  '@media (min-width: 768px)': {
    accordionTitleHead: {
      padding: '4px 24px',
      '& p': {
        marginLeft: '-16px',
        fontSize: '16px',
      },
      '& svg': {
        fontSize: '26px',
      },
    },
    accordianDetails: {
      padding: '0px 24px 8px 24px',
    },
  },
});

export default styles;
